export const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1100,
  },

  modal: (isMobile) => ({
    width: isMobile ? "90%" : 400,
    background: "#fff",
    borderRadius: 10,
    padding: 16,
    overflowY: "auto",
  }),

  header: {
    marginTop: 0,
  },

  typeSelectorContainer: {
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },

  typeSelector: {
    padding: 6,
    borderRadius: 6,
    border: "1px solid #ccc",
    width: "50%",
  },

  searchContainer: (isMobile) => ({
    position: "relative",
    marginBottom: isMobile ? "1px" : "20px",
    display: "flex",
    alignItems: "center",
  }),

  input: (isMobile) => ({
    flex: 1,
    padding: 6,
    paddingLeft: 30, // espaço para a lupa
    borderRadius: 6,
    border: "1px solid #ccc",
    boxSizing: "border-box",
  }),

  svg: (isMobile) => ({
    position: "absolute",
    left: 8,
    width: isMobile ? 16 : 20,
    height: isMobile ? 16 : 20,
    fill: "#888",
    pointerEvents: "none",
  }),

  listContainer: {
    maxHeight: 130,
    overflowY: "auto",
    marginBottom: 12,
  },

   
  

  listItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: 8,
    borderBottom: "1px solid #eee",
  },

  listItemLeft: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },

  button: (primary) => ({
    padding: "10px 8px",
    borderRadius: 6,
    border: primary ? "none" : "1px solid #ccc",
    background: primary ? "#1F3A70" : "#f5f5f5",
    color: primary ? "#fff" : "#000",
    cursor: "pointer",
  }),

  actionButtons: {
    marginTop: 12,
    display: "flex",
    gap: 8,
  },

  sectionTitle: {
    margin: "0 0 8px 0",
  },
};